import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
export var CenterBox = styled(Box)({
  alignContent: 'center',
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  minHeight: 150
});